import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

/* eslint-disable max-lines */
import _ from 'lodash';
import { parseTime } from '@/filters/index';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import SearchBar from '@/components/SearchV3/index.vue';
import { getFeedbackList } from '@/api/website/message';
import AutoTips from '@/components/AutoTips/index.vue';

export default {
  components: {
    Pagination: Pagination,
    TableList: TableList,
    SearchBar: SearchBar,
    AutoTips: AutoTips
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        adv_id: '',
        time: [],
        order: '-created_time'
      },
      pagination: {
        total: 0
      },
      listLoading: false,
      list: [],
      formItemList: [{
        type: 'date-picker',
        subtype: 'daterange',
        prop: 'time',
        class: 'date-picker',
        params: {
          clearable: true,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期'
        }
      }, {
        prop: 'adv_id',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          valueKey: 'id',
          clearable: true,
          placeholder: '请输入账号名'
        }
      }, {
        type: 'input',
        prop: 'email',
        subtype: 'text',
        params: {
          clearable: true,
          placeholder: '请输入邮箱'
        }
      }]
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.getList(this.query);
    }
  },
  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '帐号名称',
        prop: 'adv_name'
      }, {
        label: '帐号邮箱',
        prop: 'email'
      }, {
        label: '联系人',
        prop: 'contact'
      }, {
        label: '套餐名',
        prop: 'plan_names'
      }, {
        prop: 'content',
        slot: 'content-cell'
      }, {
        label: '留言时间',
        prop: 'created_time',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return parseTime(row.created_time, '{y}-{m}-{d} {h}:{i}:{s}');
          }
        }
      }];
    }
  },
  mounted: function mounted() {
    this.getList(this.query);
  },

  methods: {
    getList: function getList(query) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var postData, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                postData = _extends({}, query);
                // 更新时间

                _context.prev = 1;

                _this.listLoading = true;
                _context.next = 5;
                return getFeedbackList(postData);

              case 5:
                res = _context.sent;

                _this.listLoading = false;
                _this.list = _.get(res, 'data.data.list', []);
                _this.pagination.total = _.get(res, 'data.data.total', 0);
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 11]]);
      }))();
    }
  }
};